// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
._2rkoglpi{border-radius:var(--ds-border-radius,4px)}._1bsb1pna{width:420px}
._1bsbnklw{width:20pc}
._4t3i11ux{height:140px}
._4t3i7iqz{height:87pt}
._ca0q1b66{padding-top:var(--ds-space-050,4px)}
._n3td1b66{padding-bottom:var(--ds-space-050,4px)}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/link-datasource/dist/esm/ui/common/modal/display-view-dropdown/display-view-drop-down.compiled.css"],"names":[],"mappings":";AACA,WAAW,yCAAyC,CAAC,WAAW,WAAW;AAC3E,WAAW,UAAU;AACrB,WAAW,YAAY;AACvB,WAAW,WAAW;AACtB,WAAW,mCAAmC;AAC9C,WAAW,sCAAsC","sourcesContent":["\n._2rkoglpi{border-radius:var(--ds-border-radius,4px)}._1bsb1pna{width:420px}\n._1bsbnklw{width:20pc}\n._4t3i11ux{height:140px}\n._4t3i7iqz{height:87pt}\n._ca0q1b66{padding-top:var(--ds-space-050,4px)}\n._n3td1b66{padding-bottom:var(--ds-space-050,4px)}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
